import AppRoutes from '@/const/routes';

export const useLayoutFlags = (pathname: string, isSafari: boolean) => {
	const isInbox = pathname.includes('inbox');
	const isClientMyCases = pathname.includes(AppRoutes.CLIENTAPP_MY_CASES);
	const isClientDashboard = pathname.includes(AppRoutes.CLIENTAPP_DASHBOARD);
	const isLawyerClientDir = pathname === '/lawyerapp/client-directory';
	const isLawyerClientProfile = pathname.includes('/lawyerapp/client-profile');
	const isCustomerSupport = pathname.includes('/clientapp/customer-support');
	const isClientCasesPage = pathname.includes('clientapp/cases');
	const isLawyerInbox = pathname.includes(AppRoutes.LAWYERAPP_INBOX);
	const isClientInbox = pathname.includes(AppRoutes.CLIENTAPP_INBOX);
	const isLawyerInboxDetail = pathname.startsWith(
		`${AppRoutes.LAWYERAPP_INBOX}/`
	);
	const isSettings =
		pathname.includes(AppRoutes.CLIENTAPP_SETTINGS) ||
		pathname.includes(AppRoutes.LAWYERAPP_SETTINGS);

	const safariCasesOrDashboard =
		isSafari && (isClientDashboard || isClientMyCases);

	return {
		isInbox,
		isClientMyCases,
		isClientDashboard,
		isLawyerClientDir,
		isLawyerClientProfile,
		isCustomerSupport,
		isClientCasesPage,
		isLawyerInbox,
		isClientInbox,
		isLawyerInboxDetail,
		isSettings,
		safariCasesOrDashboard,
	};
};
